import { Component, OnInit, EventEmitter, Output, Input, OnDestroy } from '@angular/core';
import { AutomationService } from '../../automation.service';
import { STATUS_CODES } from '../../../common/constants/defines';
import { Router } from '@angular/router';

@Component({
    selector: 'services-specification-names-add',
    templateUrl: './services-specification-names-add.component.html',
    styleUrls: ['./services-specification-names-add.component.css']
})
export class ServicesSpecificationNamesAddComponent implements OnInit, OnDestroy {

    public serviceSpec: any = {
        name: '',
        type: ''
    };

    public flows: any[] = [];

    public formErrors: any[] = [];

    public statusCodes = STATUS_CODES;

    public identifierTypes: string[] = ['uri', 'queryString', 'jsonPath', 'x-www-form-urlencoded'];

    public serviceSpecTypes: string[] = ['string', 'number', 'boolean', 'array-of-string', 'array-of-number', 'array-of-boolean'];

    public errorOverLay = null;

    constructor(private automationService: AutomationService, private router: Router) { }

    ngOnDestroy(): void {

        this.automationService.registerSpinner.next(false);
    }

    public ngOnInit() {

        this.addFlow();
    }


    public addFlow() {

        this.flows.push({
            serviceName: '',
            isMain: false,
            isActive: true,
            jsonPaths: [],
            defaultStub: null
        });
    }


    public removeFlow(index: number) {

        this.flows.splice(index, 1);
    }
    public addDefaultStub(flow) {

        flow.defaultStub = {
            name: '',
            respCode: ''
        };
    }

    public removeDefaultStub(flow) {

        flow.defaultStub = null;
    }

    public addJsonPath(flow) {

        flow.jsonPaths = flow.jsonPaths ? flow.jsonPaths : [];

        flow.jsonPaths.push({
            path: '',
            propName: '',
            forIdentifiers: false,
            identifierType: ''
        });
    }

    public removeJsonPath(flows, index: number) {

        flows.jsonPaths.splice(index, 1);
    }

    public submit() {

        this.automationService.registerSpinner.next(true);

        this.flows = this.flows.map((flow) => {

            flow.serviceName = flow.serviceName.trim();

            if (Array.isArray(flow.jsonPaths)) {

                flow.jsonPaths.map((jsonpath) => {

                    if (jsonpath.forIdentifiers) {

                        jsonpath.path = `$.${jsonpath.propName.trim()}`;

                        jsonpath.identifierJsonPath = jsonpath.identifierJsonPath ? jsonpath.identifierJsonPath.trim() : undefined;
                    } else {

                        delete jsonpath.identifierJsonPath;

                        delete jsonpath.identifierType;
                    }

                    return jsonpath;
                });
            }

            if (flow.defaultStub && flow.defaultStub.name) {

                flow.isMain = true;
            }

            return flow;
        });

        this.automationService.addServiceSpecName({
            flows: this.flows,
            name: this.serviceSpec.name.trim(),
            type: this.serviceSpec.type
        }).subscribe(() => {

            this.automationService.registerSpinner.next(false);

            this.router.navigate(['/automation']);
        }, (error) => {
                this.automationService.registerSpinner.next(false);

                if (error && error.json) {

                    this.errorOverLay = {
                        message: error.json().message
                    };
                }
        });
    }

    public isNotValidFlows() {

        let isNotValid = false;

        this.flows.forEach(flow => {

            isNotValid = isNotValid || ((!flow.jsonPaths || !flow.jsonPaths.length) && (!flow.defaultStub));
        });

        return isNotValid;
    }

    closeOverLay() {

        this.errorOverLay = null;
    }

    navigateToAutomation() {
        this.router.navigate(['automation']);
    }
}



// WEBPACK FOOTER //
// ./src/app/automation/services-specification-names/add/services-specification-names-add.component.ts